window.addEventListener("FormClientRendered", function () {
    const isGermany = document.documentElement.lang === "de-DE";

    if (!isGermany) return;

    var answers = document.querySelectorAll(".cc_known_tv .RadioAnswer");
    var amountOfAnswers = answers.length;

    function generateRandomArray(maxArrayLength, numbers = []) {
        var randomNum = Math.floor(1 + Math.random() * maxArrayLength);

        if (numbers.length < maxArrayLength) {
            if (!numbers.includes(randomNum)) {
                numbers.push(randomNum);
            }

            generateRandomArray(maxArrayLength, numbers);
        }

        return numbers;
    }

    function randomClass(maxArrayLength) {
        var numbers = generateRandomArray(maxArrayLength);

        answers.forEach(function (answer, index) {
            answer.classList.add(`order-${numbers[index]}`);
            answer.style.order = numbers[index];
        });
    }

    randomClass(amountOfAnswers);
});
